import React from "react";
import { useTranslation } from 'react-i18next';


const Inverter = ({ idInverter, name, status, statusLevel, color }) => {
    const { t } = useTranslation();
    console.log(statusLevel);
    return (
        <div className="inverter" id={idInverter}>
            <div className="line-top" />
            <div className="inverter-box" style={{ backgroundColor: color }}>
                <div className={`line-inside ${statusLevel === "0" ? "on" : "off"}`} />
            </div>
            <div className="line-bottom" />
            <div className="inverter-info">
                <div className="inverter-name">{name}</div>
                <div className="inverter-status">{t('scada.solarFarm.CT.schema.state')} {status}</div>
            </div>
        </div>
    );
}

export default Inverter
